package dk.smark.chat

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import dk.smark.chat.di.appModule
import org.koin.core.context.startKoin


@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initKoin()
    val startOnRegister = js("window.location.search.includes('register=true')") as Boolean
    ComposeViewport {
        App(startOnRegister = startOnRegister)
    }
}

fun initKoin() = startKoin {
    modules(appModule)
}